<template>
  <div class="deviceinfobox" style="display:block;flex:0;margin-top:16px;">
    <!-- 设备信息 -->
    <deviceinfo v-show="!showDevicebelong" @showdetail="showDetail"></deviceinfo>
    <!-- 设备所属数采器 -->
    <devicebelong v-show="showDevicebelong" @showdetail="showDetail"></devicebelong>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import deviceinfo from "./deviceinfo";
import devicebelong from "./devicebelong";
export default {
  components: {
    deviceinfo,
    devicebelong
  },
  data() {
    return {
      // 显示数采器页
      showDevicebelong: false,
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    })
  },
  methods: {
    // 显示所属数采器
    showDetail(val) {
			this.showDevicebelong = val;
		},
  }
}
</script>
